
import React from 'react';
import { IoIosConstruct } from 'react-icons/io';

import './home.style.css';


const Home = () => {
  return (
    <>
      <div className='under-construction'>
        Page under construction <IoIosConstruct />
      </div>
    </>
  );
};

export default Home;